const ISF10ApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACE_ISF_URL}/ace-isf/isf10/response/get`,
  GET_SN: `${process.env.REACT_APP_USER_ACE_ISF_URL}/ace-isf/isf10/responseSN/get`,
};

export default ISF10ApiUrls
